// 9fbef606107a605d69c0edbcd8029e5d
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import PropTypes from 'prop-types';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import React from 'react';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import GlobalAddEditAddressLabels, {
  GLOBAL_ADD_EDIT_ADDRESS_LABELS,
} from '@tcp/core/src/utils/labels/globalAddEditAddress.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import PickupLocation from './PickupLocation.view';
import PickupForm from '../../../container/Pickup/PickupForm.container';
import { PICKUP_FORM_NAME } from '../../../container/Pickup/Pickup.constants';

const PickupExpanded = (props) => {
  const globalAddEditAddressLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_EDIT_ADDRESS_LABELS,
    GlobalAddEditAddressLabels
  );

  const globalActionsLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ACTIONS_LABELS,
    GlobalActionsLabels
  );
  const {
    formName,
    mode,
    handleSave,
    spcLabels,
    globalLabels,
    section,
    pickupFormInput,
    requestModalClose,
    updateStoreDetails,
    savedAddress,
    getPickupFormData,
    userEmail,
    pickUpContactPerson,
    pickUpAlternatePerson,
    isHasPickUpAlternatePerson,
    shipments,
    activateSpcSection,
    saveBtnLoadingStatus,
    userPhone,
    userFirstName,
    userLastName,
    getShippingAddress,
    isLoginV2FlowEnabled,
    isShake,
    pickupFormRef,
    isPlccIC,
    pageCategory,
    bossSwitchEnabled,
    isNewEddViewCheckout,
  } = props;
  const saveBtnLabel = isPlccIC
    ? renderLabel(globalActionsLabels.lbl_save_caps, 'lbl_save_caps')
    : renderLabel(
        globalAddEditAddressLabels.lbl_addEditAddress_saveAndContinue,
        'lbl_addEditAddress_saveAndContinue'
      );
  return (
    <div className="spc-card-content">
      <BodyCopy component="div">
        {!bossSwitchEnabled && !isNewEddViewCheckout && (
          <PickupLocation shipments={shipments} {...props} />
        )}
        <PickupForm
          formName={formName}
          savedAddress={savedAddress}
          requestModalClose={requestModalClose}
          mode={mode}
          userEmail={userEmail}
          userPhone={userPhone}
          userFirstName={userFirstName}
          userLastName={userLastName}
          getShippingAddress={getShippingAddress}
          updateStoreDetails={updateStoreDetails}
          getPickupFormData={getPickupFormData}
          pickupFormInput={pickupFormInput}
          handleSave={handleSave}
          activateSpcSection={activateSpcSection}
          spcLabels={spcLabels}
          globalLabels={globalLabels}
          section={section}
          pickUpContactPerson={pickUpContactPerson}
          pickUpAlternatePerson={pickUpAlternatePerson}
          isHasPickUpAlternatePerson={isHasPickUpAlternatePerson}
          isLoginV2FlowEnabled={isLoginV2FlowEnabled}
          isPlccIC={isPlccIC}
          pageCategory={pageCategory}
          shipments={shipments}
          {...props}
        />
        {(bossSwitchEnabled || isNewEddViewCheckout) && (
          <PickupLocation shipments={shipments} {...props} />
        )}
        <Row fullBleed>
          <Col colSize={{ small: 6, medium: 4, large: 4.5 }}>
            <Button
              type="submit"
              buttonVariation="fixed-width"
              fill="BLUE"
              className={`${
                bossSwitchEnabled || isNewEddViewCheckout ? 'elem-mt-LRG' : 'elem-mb-LRG'
              } btn-border  ${isShake ? 'shake-pickup' : ''}`}
              disabled={false}
              loading={saveBtnLoadingStatus}
              onClick={() => handleSave(PICKUP_FORM_NAME)}
              ref={pickupFormRef}
              spc
            >
              {saveBtnLabel}
            </Button>
          </Col>
        </Row>
      </BodyCopy>
    </div>
  );
};

PickupExpanded.propTypes = {
  requestModalClose: PropTypes.shape({}).isRequired,
  updateStoreDetails: PropTypes.shape({}).isRequired,
  savedAddress: PropTypes.shape({}).isRequired,
  getPickupFormData: PropTypes.shape({}).isRequired,
  userEmail: PropTypes.string.isRequired,
  pickUpContactPerson: PropTypes.shape({}).isRequired,
  pickUpAlternatePerson: PropTypes.shape({}).isRequired,
  isHasPickUpAlternatePerson: PropTypes.shape({}).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  formName: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  handleSave: PropTypes.func.isRequired,
  pickupFormInput: PropTypes.shape({}).isRequired,
  shipmentMethods: PropTypes.shape({}),
  spcLabels: PropTypes.shape({ editPickupInfoTitle: '' }).isRequired,
  giftServicesInput: PropTypes.shape({}).isRequired,
  savedGiftService: PropTypes.shape({}).isRequired,
  globalLabels: PropTypes.shape({}),
  section: PropTypes.shape({}).isRequired,
  isLoginV2FlowEnabled: PropTypes.bool,
};

PickupExpanded.defaultProps = {
  shipmentMethods: {},
  globalLabels: {},
  isLoginV2FlowEnabled: false,
};

export default errorBoundary(PickupExpanded);
